import { IPromo } from './Promo';
import { ISku } from './Sku';

export const DefaultProduct = (): IProduct => {
    return {
        id: '',
        productType: ProductType.Phone,
        baseInfo: DefaultBaseInfo(),
        pricing: DefaultPricing(),
        baseSkus: [],
        baseImages: [],
        colorOptions: [DefaultColorOption()],
        features: [],
        featureIconLines: [],
        legalText: [],
        specs: [],
        details: [],
        promos: [],
        isVisible: true,
        enableTradeIn: true,
        enableAssurancePlan: true
    };
};

export interface IProduct {
    id: string;
    productType: ProductType;
    baseInfo: IBaseInfo;
    pricing: IPricing;
    baseSkus: ISku[];
    baseImages: string[];
    colorOptions: IColorOption[];
    features: IFeature[];
    featureIconLines: IFeatureIconLine[];
    legalText: ILegalText[];
    specs: ISpec[];
    details: IDetail[];
    promos: IPromo[];
    isVisible: boolean;
    enableTradeIn: boolean;
    enableAssurancePlan: boolean;
}

export enum ProductType {
    Phone = 'phone',
    Device = 'device',
    Accessory = 'accessory'
}

export interface IBaseInfo {
    name: string;
    description: IValueWithLegal;
    releaseDate: Date;
    brand: string;
    sortOrder: number;
}

export const DefaultBaseInfo = (): IBaseInfo => {
    return {
        name: 'baseInfo',
        description: DefaultValueWithLegal(),
        releaseDate: new Date(),
        brand: 'testBrand',
        sortOrder: 0
    };
};

export interface IPricing {
    retail: number;
    monthly: number;
    numMonths: number;
    downPayment: IDownPayment;
}

export const DefaultPricing = (): IPricing => {
    return {
        retail: 0,
        downPayment: DefaultDownPayment(),
        monthly: 0,
        numMonths: 0
    };
};

export interface IDownPayment extends IDescriptionField {
    minUpfront: number;
}

export const DefaultDownPayment = (): IDownPayment => {
    return {
        ...DefaultDescriptionField(),
        minUpfront: 0
    };
};

export interface IDescriptionField {
    visible: boolean;
    description: IValueWithLegal;
    subDescription: IValueWithLegal[];
    moreDetails: IValueWithLegal[];
}

export const DefaultDescriptionField = (): IDescriptionField => {
    return {
        visible: true,
        description: DefaultValueWithLegal(),
        moreDetails: [],
        subDescription: []
    };
};

export interface IColorOption {
    name: string;
    value: string;
    isPattern: boolean;
    images: string[];
}

export const DefaultColorOption = (): IColorOption => {
    return {
        images: [''],
        isPattern: false,
        name: '',
        value: ''
    };
};

export interface IFeature {
    image: string;
    text: IValueWithLegal;
    isIcon: boolean;
    isFocus: boolean;
}

export interface IFeatureIconLine {
    icon: string;
    text: IValueWithLegal;
}

export interface ISpec {
    name: string;
    values: ISpecItem[];
}

export interface ISpecItem {
    attributeName: string;
    value: IValueWithLegal;
}

export interface IDetail {
    name: string;
    value: IValueWithLegal[];
    secondColumnValue: IValueWithLegal[];
}

export interface IValueWithLegal {
    value: string;
    legalTextIds: string[];
}

export const DefaultValueWithLegal = () => {
    return {
        value: 'value with legal',
        legalTextIds: []
    };
};

export interface ILegalText {
    id: string;
    text: string;
}

export const DefaultLegalText = (): ILegalText => {
    return {
        id: '',
        text: ''
    };
};

export interface IAcceptedBrandResponse {
    id: string;
    name: string;
}
